export const BANKIRU_URL = "https://www.banki.ru";

export const getBankOfYearUrl = year => `${BANKIRU_URL}/bankofyear/${year}/`;

export const MAX_YEAR = 2021;
